import { render, staticRenderFns } from "./WebSocket.vue?vue&type=template&id=48c523f5&"
import script from "./WebSocket.vue?vue&type=script&lang=js&"
export * from "./WebSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports